import { ButtonBase, Stack, Typography } from '@mui/material';
import { AccountTabBox } from '@/components/content/Account/parts/icons/AccountTabBox';
import { AccountAddress } from '@/components/content/Account/parts/icons/AccountAddress';
import { AccountDp } from '@/components/content/Account/parts/icons/AccountDp';
import { AccountBox } from '@/components/content/Account/parts/icons/AccountBox';
import { AccountFavorite } from '@/components/content/Account/parts/icons/AccountFavorite';
import { AccountTabsButtonSX, AccountTabsNameSX } from '@/components/content/Account/styles/tabs';
import { useEffect, useRef } from 'react';

export enum ACCOUNT_TABS {
	PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
	ADDRESSES = 'ADDRESSES',
	LOYALTY_PROGRAM = 'LOYALTY_PROGRAM',
	ORDERS_HISTORY = 'ORDERS_HISTORY',
	FAVORITES = 'FAVORITES',
	CLUBDP_POINTS = 'CLUBDP_POINTS',
	SUMMARY = 'SUMMARY',
	RESUME = 'RESUME',
}

export const ACCOUNT_TABS_ITEMS = [
	{
		id: ACCOUNT_TABS.PERSONAL_INFORMATION,
		name: 'Información personal',
		icon: <AccountTabBox />,
	},
	{
		id: ACCOUNT_TABS.ADDRESSES,
		name: 'Direcciones',
		icon: <AccountAddress />,
	},
	// {
	// 	id: ACCOUNT_TABS.LOYALTY_PROGRAM,
	// 	name: 'Programa de lealtad',
	// 	icon: <AccountDp />,
	// },
	{
		id: ACCOUNT_TABS.CLUBDP_POINTS,
		name: 'Clubdppuntos',
		icon: <AccountDp />,
	},
	{
		id: ACCOUNT_TABS.ORDERS_HISTORY,
		name: 'Historial de pedidos',
		icon: <AccountBox />,
	},
	{
		id: ACCOUNT_TABS.FAVORITES,
		name: 'Favoritos',
		icon: <AccountFavorite />,
	},
];

interface AccountTabProps {
	items: {
		id: ACCOUNT_TABS;
		name: string;
		icon: React.ReactElement;
	}[];
	select?: ACCOUNT_TABS;
	onSelect?: (tab: ACCOUNT_TABS) => void;
}

export const AccountTabs: React.FC<AccountTabProps> = ({ items, select, onSelect }) => {
	const scrollRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		setTimeout(() => {
			if (!scrollRef.current || !select) {
				return;
			}
			const selectedTab = document.getElementById(select);

			if (!selectedTab) {
				return;
			}

			const scrollWidth = scrollRef.current.scrollWidth;
			const clientWidth = scrollRef.current.clientWidth;
			const scrollLeft = selectedTab.offsetLeft - clientWidth / 2 + selectedTab.clientWidth / 2;

			if (scrollLeft < 0) {
				scrollRef.current.scrollTo({ left: 0, behavior: 'smooth' });
			} else if (scrollLeft + clientWidth > scrollWidth) {
				scrollRef.current.scrollTo({ left: scrollWidth, behavior: 'smooth' });
			} else {
				scrollRef.current.scrollTo({ left: scrollLeft, behavior: 'smooth' });
			}
		}, 300);
	}, [select]);

	return (
		<Stack
			ref={scrollRef}
			direction="row"
			spacing={2}
			overflow="auto"
			paddingBottom={{ xs: '8px;', sm: '0px' }}
		>
			{items.map((item) => (
				<ButtonBase
					key={item.id}
					id={item.id}
					sx={AccountTabsButtonSX(item.id === select)}
					onClick={() => onSelect && onSelect(item.id)}
				>
					{item.icon}
					<Typography sx={AccountTabsNameSX}>{item.name}</Typography>
				</ButtonBase>
			))}
		</Stack>
	);
};
